import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  adminId: null,
  name: null,
  email: null,
  admin_type: null,
  modules: null,
  booking_fee: null,
  companies: null,
  teacher_id: null,
  user_type: null,
  company_id: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.token = action.payload.token;
      state.adminId = action.payload.adminId;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.admin_type = action.payload.admin_type;
      state.modules = action.payload.modules;
      state.booking_fee = action.payload.booking_fee;
      state.companies = action.payload.companies;
      state.teacher_id = action.payload.teacher_id;
      state.user_type = action.payload.user_type;
      state.company_id = action.payload.company_id;
    },
    clearAuthData: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.adminId = null;
      state.name = null;
      state.email = null;
      state.admin_type = null;
      state.modules = null;
      state.booking_fee = null;
      state.companies = null;
      state.teacher_id = null;
      state.user_type = null;
      state.company_id = null;
    },
    updateAuthToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { setAuthData, clearAuthData, updateAuthToken } = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectAdminId = (state) => state.auth.adminId;
export const selectUserType = (state) => state.auth.user_type;
export const selectCompanyId = (state) => state.auth.company_id;
export const selectTeacherId = (state) => state.auth.teacher_id;
export const selectModules = (state) => state.auth.modules;

export default authSlice.reducer;
